/**
 * Created by kubla on 11/04/17.
 */

export default {
  methods: {
    clearToasts: function (position, max){
      if (_.size(this.$root.$children[0].$refs.toastr.list[position]) >= max){
        _.forOwn(this.$root.$children[0].$refs.toastr.list[position] ,function(value, key) {
          this.$root.$children[0].$refs.toastr.removeToast({index: key, position: position});
        }.bind(this));
        //
      }
    },
    newMessageToast: function (title, message) {
      this.clearToasts("toast-bottom-right", 2);
      this.$root.$children[0].$refs.toastr.Add({
        title: title, // Toast Title
        msg: message, // Message
        clickClose: true, // Click Close Disable
        position: "toast-bottom-right", // Toast Position.
        type: "success", // Toast type
        progressbar: false
      });
    },
    // infoToast: function (title, message, type) {
    //   this.clearToasts("toast-top-center", 2);
    //   this.$root.$children[0].$refs.toastr.Add({
    //     title: title, // Toast Title
    //     msg: message, // Message
    //     clickClose: true, // Click Close Disable
    //     position: "toast-top-center", // Toast Position.
    //     type: type, // Toast type
    //     progressbar: false
    //   });
    // },
    errorToast: function (title, message) {
      this.clearToasts("toast-bottom-center", 1);
      this.$root.$children[0].$refs.toastr.Add({
        title: title, // Toast Title
        msg: message, // Message
        clickClose: true, // Click Close Disable
        position: "toast-bottom-center", // Toast Position.
        type: "error", // Toast type
        progressbar: true
      });
    },
    successToast: function (title, message) {
      this.clearToasts("toast-bottom-center", 1);
      this.$root.$children[0].$refs.toastr.Add({
        title: title, // Toast Title
        msg: message, // Message
        clickClose: true, // Click Close Disable
        position: "toast-bottom-center", // Toast Position.
        type: "success", // Toast type
        progressbar: true
      });
    },
  }
}
